import { render, staticRenderFns } from "./AgendamentoList.vue?vue&type=template&id=1e742e7b&scoped=true"
import script from "./AgendamentoList.vue?vue&type=script&lang=ts"
export * from "./AgendamentoList.vue?vue&type=script&lang=ts"
import style0 from "./AgendamentoList.vue?vue&type=style&index=0&id=1e742e7b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e742e7b",
  null
  
)

export default component.exports